interface PricingGroup {
    pricingGroupId: string;
    deleted: boolean;
}

/**
 * Auto detect the `pricingGroupId` from a list of pricing groups
 *
 * This is possible when the "Automatic" pricing group option is unavailable (i.e.
 * there are no pricing group move rules setup) and when there's only one active
 * pricing (i.e. non-deleted) group to choose from.
 *
 * @param canChooseAutoPricingGroup
 * @param pricingGroups
 */
export const getAutoPricingGroupId = (
    canChooseAutoPricingGroup: boolean,
    pricingGroups: Array<PricingGroup>,
): string | null => {
    if (canChooseAutoPricingGroup) {
        return null;
    }

    const activePricingGroups = pricingGroups.filter(pricingGroup => !pricingGroup.deleted);

    return activePricingGroups.length === 1 ? activePricingGroups[0].pricingGroupId : null;
};
